var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-sync"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync",
    clipPath: "url(#clip-sync)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10370",
    "data-name": "Group 10370",
    transform: "translate(-50.534 -310.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Expanded",
    transform: "translate(52.134 313.725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21200",
    "data-name": "Path 21200",
    d: "M54.185,321.007a.278.278,0,0,1-.2-.1l-1.768-2.031a.271.271,0,0,1,0-.384.263.263,0,0,1,.376,0l1.5,1.761,1.264-1.964a.278.278,0,0,1,.376-.075.263.263,0,0,1,.075.369l-1.46,2.257a.263.263,0,0,1-.211.128Z",
    transform: "translate(-52.134 -314.827)",
    fill: "#4e85f3",
    stroke: "#4e85f3",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21201",
    "data-name": "Path 21201",
    d: "M67.689,321.893a.271.271,0,0,1-.226-.113l-1.3-1.941-1.5,1.791a.278.278,0,0,1-.384,0,.271.271,0,0,1,0-.384L66,319.177a.241.241,0,0,1,.218-.1.294.294,0,0,1,.211.12l1.5,2.257a.256.256,0,0,1-.068.369A.271.271,0,0,1,67.689,321.893Z",
    transform: "translate(-55.121 -315.051)",
    fill: "#4e85f3",
    stroke: "#4e85f3",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21202",
    "data-name": "Path 21202",
    d: "M59.625,324.774a4.838,4.838,0,0,1-3.4-1.4.271.271,0,1,1,.384-.384,4.319,4.319,0,0,0,7.32-3.559.256.256,0,0,1,.233-.293.263.263,0,0,1,.3.233,4.875,4.875,0,0,1-4.838,5.4Z",
    transform: "translate(-53.127 -315.065)",
    fill: "#4e85f3",
    stroke: "#4e85f3",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21203",
    "data-name": "Path 21203",
    d: "M54.731,319.906a.271.271,0,0,1-.263-.211,4.854,4.854,0,0,1,8.359-4.334.272.272,0,0,1-.406.361,4.311,4.311,0,0,0-7.426,3.845.286.286,0,0,1-.2.331Z",
    transform: "translate(-52.68 -313.725)",
    fill: "#4e85f3",
    stroke: "#4e85f3",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ff2040ab.svg";
export { ForwardRef as ReactComponent };